import { useTranslation } from "react-i18next";
import { Dialog, DialogActions, DialogDescription, DialogTitle } from "src/components/base/dialog";
import { Button } from "src/components/base/button";
import React from "react";
import { ApiInternal } from "src/api/api_internal";
import { UUID } from "src/api/api_common";

/**
 * The properties for {@link DeleteExtraDomainDialog}
 */
export type DeleteExtraDomainDialogProps = {
    /** The uuid of the dns */
    dns: UUID;
    /** Callback function when the Dialog is closed */
    onClose: () => void;
    /** Callback function when the file is deleted */
    onDelete: () => void;
};

/**
 * A dialog for adding a new split dns domain
 */
export default function DeleteExtraDomainDialog(props: DeleteExtraDomainDialogProps) {
    const [t] = useTranslation("dialog-delete-extra-domain");

    /**
     * Delete the dns
     */
    const deleteDns = async () => {
        await ApiInternal.dns.deleteExtraDns(props.dns);
        props.onDelete();
    };

    return (
        <Dialog onClose={props.onClose} open={true}>
            <DialogTitle>{t("heading.delete-extra-domain")}</DialogTitle>
            <DialogDescription>{t("description.delete-extra-domain")}</DialogDescription>
            <DialogActions>
                <Button autoFocus={true} onClick={props.onClose}>
                    {t("button.cancel")}
                </Button>
                <Button color={"red"} onClick={deleteDns}>
                    {t("button.delete")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
